'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

var _options = require('../common/options');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineComponent = function (_BaseComponent) {
    (0, _inherits3.default)(LineComponent, _BaseComponent);

    function LineComponent(props) {
        (0, _classCallCheck3.default)(this, LineComponent);
        return (0, _possibleConstructorReturn3.default)(this, (LineComponent.__proto__ || (0, _getPrototypeOf2.default)(LineComponent)).call(this, props));
    }

    /**
     * 矫正 option
     */


    (0, _createClass3.default)(LineComponent, [{
        key: 'packageOption',
        value: function packageOption() {
            var option = JSON.parse((0, _stringify2.default)((0, _assign2.default)({}, _options.LineOption)));
            var _props = this.props,
                type = _props.type,
                color = _props.color,
                title = _props.title,
                subTitle = _props.subTitle,
                _props$titleX = _props.titleX,
                titleX = _props$titleX === undefined ? 'left' : _props$titleX,
                _props$padding = _props.padding,
                padding = _props$padding === undefined ? {} : _props$padding,
                _props$orient = _props.orient,
                orient = _props$orient === undefined ? 'horizontal' : _props$orient,
                _props$legendX = _props.legendX,
                legendX = _props$legendX === undefined ? 'center' : _props$legendX,
                _props$legendY = _props.legendY,
                legendY = _props$legendY === undefined ? 'auto' : _props$legendY,
                hasLegend = _props.hasLegend,
                hasToolbox = _props.hasToolbox,
                hasTooltip = _props.hasTooltip,
                hasX = _props.hasX,
                hasY = _props.hasY,
                hasGridV = _props.hasGridV,
                hasGridH = _props.hasGridH,
                animation = _props.animation,
                _props$boundaryGap = _props.boundaryGap,
                boundaryGap = _props$boundaryGap === undefined ? false : _props$boundaryGap,
                data = _props.data;

            if (color && color.length) {
                option.color = color;
            }
            option.title.text = title;
            option.title.subtext = subTitle;
            option.title.x = titleX;
            option.tooltip.show = hasTooltip;
            option.legend.show = hasLegend;
            option.legend.bottom = legendY;
            option.legend.x = legendX;
            option.legend.orient = orient;
            (0, _assign2.default)(option.grid, padding);
            option.toolbox.show = hasToolbox;
            option.xAxis.show = hasX;
            option.yAxis.show = hasY;
            option.xAxis.boundaryGap = boundaryGap;
            option.xAxis.splitLine.show = hasGridV;
            option.yAxis.splitLine.show = hasGridH;
            option.animation = animation;

            // 设置 series
            this.collectionSeries(data, option);
            if (type === 'area') {
                option.toolbox.axisPointer = {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                };
            }

            return option;
        }

        /**
         * 
         * 收集 series
         */

    }, {
        key: 'collectionSeries',
        value: function collectionSeries(data, defaultOption) {
            var type = this.props.type;

            var yData = data.data || [];
            var option = null;
            defaultOption.legend.data = [];
            defaultOption.xAxis.data = [];
            defaultOption.series = [];
            if (type === 'area') {
                option = {
                    type: 'line',
                    stack: '总量',
                    areaStyle: {
                        normal: {}
                    }
                };
            } else if (type === 'marker') {
                option = {
                    type: 'line',
                    markPoint: {
                        data: [{
                            type: 'max',
                            name: '最大值'
                        }, {
                            type: 'min',
                            name: '最小值'
                        }]
                    },
                    markLine: {
                        data: [{
                            type: 'average',
                            name: '平均值'
                        }]
                    }
                };
            } else {
                option = {
                    type: 'line',
                    data: null
                };
            }
            if (Object.prototype.toString.call(yData) === '[object Array]' && yData.length) {
                yData.forEach(function (item) {
                    defaultOption.legend.data.push(item.name);
                    defaultOption.series.push((0, _assign2.default)({}, option, item));
                });
            } else if (Object.prototype.toString.call(yData) === '[object Object]') {
                defaultOption.legend.data.push(yData.name);
                defaultOption.series.push((0, _assign2.default)({}, option, yData));
            }
            // 收集横坐标
            defaultOption.xAxis.data = data.x;
        }
    }]);
    return LineComponent;
}(_Base2.default);

exports.default = LineComponent;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-chart@0.0.14@@alicd/crui-chart/lib/components/Line.js
// module id = 602
// module chunks = 0